import React from 'react';
import { Accordion } from '../../../../../../components';
import { useTealium } from '../../../../../../tealium/useTealium';
import { FundingDetailsTable } from './fundingDetailsTable/fundingDetailsTable';
import { ArrowDown } from '../../../../../../assets';
import { AccordionStyle } from '../../../../../../constants';
import styles from '../Withdrawal.module.css';
import PropTypes from 'prop-types';

export const FundingDetailsAccordion = ({ open, toggle, amtToWithdrawResp, onChangeAmountClick, businessId, applicationId, isMobile }) => {
  const { track, events } = useTealium();
  return(
    <Accordion
      isOpen={open === 'fundingDetails'}
      containerStyle={isMobile ? { borderRadius: 19 } : { borderRadius: 8 }}
      headerChildren={
        <>
          <div style={AccordionStyle.accordionHeaderLeft}>
            <div className={styles.withdrawlAccordionTitle}>Funding details</div>
          </div>
          <img
            style={{ ...AccordionStyle.ArrowImg, rotate: open === 'fundingDetails' ? '180deg' : '' }}
            src={ArrowDown}
            alt='DropdownOpen'
            role='presentation'
            onClick={() => {track(events.creditFacility.toggleAccordian('fundingDetails', open === 'fundingDetails' ? 'collapse': 'expand')); toggle(open === 'fundingDetails' ? '' : 'fundingDetails');}}
          />
        </>
      }
    >
      {amtToWithdrawResp !== 'withdrawalInProgress' && (
        <div className={styles.accordion}>

          <FundingDetailsTable
            withdrawalDetails={amtToWithdrawResp}
            onClick={ onChangeAmountClick}
            businessId={businessId}
            applicationId={applicationId}
          />
        </div>
      )}
    </Accordion>
  );
};
FundingDetailsAccordion.propTypes = {
  open: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired,
  amtToWithdrawResp: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  onChangeAmountClick: PropTypes.func.isRequired,
  applicationId: PropTypes.string.isRequired,
  businessId: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired
};